import React from 'react';
import { Modal } from 'react-bootstrap';
import * as yup from 'yup';
import moment from 'moment';
import { withFormik } from 'formik';
import {useSelector, useDispatch} from "react-redux";
import {addGuests} from "../../../../../../general_redux/guest/actions";
import AddGuestForm from "../../../Guest/components/AddGuests/AddGuestForm";
import styles from './addspecialbooking.module.css';

function AddGuest(props) {
    const dispatch = useDispatch();
    const user = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);

    const handleSubmit = async (data) => {
        const payload={
            name: data.name,
            emailId:data.emailId,
            phoneNo:data.phoneNo.split(" ")?.length ===1 ? "" : data.phoneNo,
            secondaryPhoneNo: data.secondaryPhoneNo.split(" ")?.length ===1 ? "" : data.secondaryPhoneNo,
            postalCode: data.postalCode,
            secondaryEmailId: data.secondaryEmailId ,
            country: data.country,
            address: data.address,
            street: data.street,
            state:data.state,
            nationality:data.nationality,
            language:data.language,
            company:data.company,
            companyAddress:data.companyAddress,
            notes:data.notes,
            dob: data.dob ? moment(data.dob).format("YYYY-MM-DD") : ''
        }
        dispatch(addGuests(payload)).then((res) => props.handleClose(res.data.guest));
    }

    const phoneRegExp = /^[0-9-+\s()]*$/;

    const FormikEnhancer = withFormik({
        validationSchema:yup.object({
            name: yup.string().max(150, 'Must be 150 characters or less').required('Name is a required field'),
            company: yup.string().max(150, 'Must be 150 characters or less'),
            companyAddress: yup.string().max(150, 'Must be 150 characters or less'),
            emailId:yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
            secondaryEmailId :yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
            phoneNo:yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.'),
            secondaryPhoneNo:yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.'),
            country: yup.string().max(50, 'Must be 50 characters or less'),
            address: yup.string().max(150, 'Must be 150 characters or less'),
            postalCode: yup.string().max(50, 'Must be 50 characters or less'),
            street: yup.string().max(150, 'Must be 150 characters or less'),
            state: yup.string().max(150, 'Must be 150 characters or less'),
            nationality:yup.string().max(150, 'Must be 150 characters or less'),
            language:yup.string().max(150, 'Must be 150 characters or less'),
            notes:yup.string().max(250, 'Must be 250 characters or less'),
            dob: yup.date().typeError('Must be a value of type date').nullable(),
        }),
        mapPropsToValues: (props)=>({
            name: "",
            company: "",
            companyAddress: "",
            emailId: "",
            secondaryEmailId: "",
            phoneNo: "",
            secondaryPhoneNo: "",
            postalCode: "",
            country: user.country,
            address: "",
            nationality: "",
            street: "",
            state: "",
            language: "",
            notes: "",
            dob: null,
        }),
        validateOnBlur:false,
        validateOnChange:false,
        handleSubmit :  (values, { setSubmitting }) => {
            handleSubmit(values);
            setSubmitting(false);
        },
        displayName: 'AddGuestForm',
    })(AddGuestForm);

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title className={styles.modalTitle}>Add guest</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormikEnhancer customFieldClass={"col-12"} customLabelClass={"col-12"}/>
            </Modal.Body>
        </>
    )
}

export default AddGuest;